export interface Testimonial {
  id: string;
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-001',
    name: '张明',
    role: '自由职业设计师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20clean%20simple%20headshot%2C%20warm%20lighting%2C%20neutral%20background%2C%20professional%20look&width=80&height=80&seq=avatar-001&orientation=squarish',
    content: '用了91免费版快两年了，最让我惊喜的是PDF转换功能，完全免费而且效果一点不比付费软件差。界面也越来越好看了，更新很及时，推荐给身边很多朋友了。',
    rating: 5,
  },
  {
    id: 't-002',
    name: '李婷',
    role: 'IT项目经理',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20clean%20simple%20headshot%2C%20warm%20lighting%2C%20neutral%20background%2C%20professional%20look&width=80&height=80&seq=avatar-002&orientation=squarish',
    content: '作为项目经理，经常需要处理各种文档和文件。91免费版的批量处理功能简直是救命神器，以前要花一上午的活现在半小时就搞定，团队效率提升太明显了。',
    rating: 5,
  },
  {
    id: 't-003',
    name: '王磊',
    role: '大学生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%2C%20clean%20simple%20headshot%2C%20warm%20lighting%2C%20neutral%20background%2C%20friendly%20look&width=80&height=80&seq=avatar-003&orientation=squarish',
    content: '学生党预算有限，91免费版真的是福音。视频剪辑功能简单好用，做课程作业完全够用了。而且安装包不大，老电脑也能流畅运行，点赞！',
    rating: 5,
  },
  {
    id: 't-004',
    name: '陈芳',
    role: '自媒体创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20female%20portrait%2C%20clean%20simple%20headshot%2C%20warm%20lighting%2C%20neutral%20background%2C%20artistic%20look&width=80&height=80&seq=avatar-004&orientation=squarish',
    content: '做自媒体经常需要录屏和剪辑，91免费版的屏幕录制功能超级清晰，剪辑工具也很顺手。关键是完全免费还没有水印，对我们内容创作者太友好了。',
    rating: 4,
  },
  {
    id: 't-005',
    name: '赵强',
    role: '小型企业主',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20male%20business%20portrait%2C%20clean%20simple%20headshot%2C%20warm%20lighting%2C%20neutral%20background%2C%20confident%20look&width=80&height=80&seq=avatar-005&orientation=squarish',
    content: '小公司预算紧张，91免费版帮我们省了不少软件采购费用。数据恢复功能还帮我找回了一次误删的重要合同文件，真心感谢开发团队做出这么好的免费工具。',
    rating: 5,
  },
];